export const STATUS_PENDIENTE            = 'pendiente';
export const STATUS_EMTREGADO            = 'entregado';
export const STATUS_POR_ENTREGAR          = 'por-entregar';
export const STATUS_FINALIZADO           = 'finalizado';
